import script from "./AutoPatternTool.vue?vue&type=script&lang=js"
export * from "./AutoPatternTool.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__